module.exports = __webpack_public_path__ + "static/img/bathroom2-thumb.7644b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/bathroom2-thumb.jpg
// module id = wD8N
// module chunks = 0